import styled from 'styled-components';

const base = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  background-color: ${(props) => props.theme.colors.background};
  width: 100%;
  height: 100vh;
`;

const Frame = {
  Base: base,
};

export default Frame;
